import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';

const Terms = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-[#0a0a0a] text-white overflow-x-hidden">
      {/* Navigation */}
      <motion.nav
        className="fixed top-0 left-0 right-0 z-50 glass-effect"
        initial={{ y: -100 }}
        animate={{ y: 0 }}
        transition={{ duration: 0.6 }}
      >
        <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
          <div className="flex items-center space-x-3">
            <a href="/">
              <img
                src="/images/logominitgps.png"
                alt="MonitGPS Logo"
                className="h-12 w-auto cursor-pointer"
              />
            </a>
          </div>

          <div className="hidden md:flex items-center space-x-8 text-sm font-medium">
            <a href="/" className="hover:text-cyan-400 transition-colors">Strona Główna</a>
            <a href="/privacy" className="hover:text-cyan-400 transition-colors">Polityka Prywatności</a>
          </div>

          {/* Mobile Menu Button */}
          <div className="md:hidden flex items-center">
            <button onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} className="text-white hover:text-cyan-400 focus:outline-none">
              <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                {isMobileMenuOpen ? (
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                ) : (
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
                )}
              </svg>
            </button>
          </div>
        </div>

        {/* Mobile Menu Dropdown */}
        {isMobileMenuOpen && (
          <div className="md:hidden bg-[#0a0a0a]/95 border-b border-white/10 flex flex-col px-6 py-4 space-y-4 text-sm font-medium backdrop-blur-xl">
            <a href="/" className="hover:text-cyan-400">Strona Główna</a>
            <a href="/privacy" className="hover:text-cyan-400">Polityka Prywatności</a>
          </div>
        )}
      </motion.nav>

      {/* Content */}
      <section className="relative pt-32 pb-24 px-6 min-h-[70vh]">
        <div className="max-w-4xl mx-auto glass-effect rounded-3xl p-8 md:p-12">
          <h1 className="font-display font-black text-4xl md:text-5xl mb-2 text-cyan-400">
            Regulamin <span className="text-white">Aplikacji</span>
          </h1>
          <p className="text-gray-500 text-sm mb-8">Aplikacja RECC MonitGPS — obowiązuje od 21 sierpnia 2026</p>

          <div className="space-y-8 text-gray-300 leading-relaxed font-light">
            <div>
              <h2 className="text-xl text-white font-bold mb-3">1. Postanowienia ogólne</h2>
              <p>
                Niniejszy Regulamin określa zasady korzystania z aplikacji mobilnej RECC MonitGPS ("Aplikacja"),
                udostępnianej przez MonitGPS ("Operator"). Kontakt z Operatorem:{' '}
                <a href="mailto:monitgpssystem@gmail.com" className="text-cyan-400 hover:underline">
                  monitgpssystem@gmail.com
                </a>.
                Zasady przetwarzania danych osobowych opisane są odrębnie w{' '}
                <a href="/privacy" className="text-cyan-400 hover:underline">Polityce Prywatności</a>.
              </p>
            </div>

            <div>
              <h2 className="text-xl text-white font-bold mb-3">2. Przeznaczenie aplikacji</h2>
              <p>
                Aplikacja jest przeznaczona wyłącznie do użytku podczas oficjalnych zapoznań z trasą rajdu
                ("recce") organizowanych przez MonitGPS oraz współpracujących organizatorów rajdów. Aplikacja
                wysyła pozycję GPS zawodnika do organizatora, aby serwis bezpieczeństwa mógł monitorować jego
                aktualne położenie w trakcie zapoznania.
              </p>
            </div>

            <div>
              <h2 className="text-xl text-white font-bold mb-3">3. Konto i logowanie — zasada jedno konto = jeden telefon</h2>
              <p>
                Dostęp do Aplikacji odbywa się przy użyciu kodu startowego przypisanego zawodnikowi przez
                organizatora rajdu. Konto zawodnika jest powiązane z jednym, konkretnym telefonem (poprzez
                unikalny identyfikator instalacji aplikacji) i nie może być jednocześnie używane na innym
                urządzeniu. Próba zalogowania tym samym kodem startowym na innym telefonie skutkuje blokadą —
                odblokowanie konta wymaga kontaktu z organizatorem rajdu.
              </p>
            </div>

            <div>
              <h2 className="text-xl text-white font-bold mb-3">4. Obowiązki użytkownika</h2>
              <p>
                Zawodnik zobowiązany jest do utrzymania włączonych uprawnień lokalizacji (w tym pracy w tle) na
                telefonie przez cały czas trwania zapoznania. Aplikacja nie gwarantuje bezpieczeństwa zawodnika
                ani ciągłości monitorowania jego pozycji, jeśli wymagane uprawnienia zostaną przez użytkownika
                wyłączone lub ograniczone.
              </p>
            </div>

            <div>
              <h2 className="text-xl text-white font-bold mb-3">5. Charakter aplikacji</h2>
              <p>
                Aplikacja nie jest narzędziem nawigacyjnym ani asystentem jazdy. Aplikacja pokazuje wyłącznie
                własną pozycję zawodnika oraz trasę odcinka i nie prowadzi nawigacji turn-by-turn ani nie
                udziela wskazówek dotyczących jazdy.
              </p>
            </div>

            <div>
              <h2 className="text-xl text-white font-bold mb-3">6. Ograniczenie odpowiedzialności</h2>
              <p>
                Operator nie ponosi odpowiedzialności za przerwy w transmisji danych wynikające z braku zasięgu
                sieci komórkowej, wyłączenia przez użytkownika wymaganych uprawnień systemowych, ograniczeń
                nałożonych przez producenta telefonu (np. agresywne zarządzanie energią) lub innych czynników
                pozostających poza kontrolą Operatora.
              </p>
            </div>

            <div>
              <h2 className="text-xl text-white font-bold mb-3">7. Zakończenie i wygaśnięcie dostępu</h2>
              <p>
                Sesja zapoznania oraz dostęp do transmisji pozycji kończą się wraz z zakończeniem rajdu, poprzez
                ręczne wylogowanie zawodnika, automatyczne zakończenie o zaplanowanej godzinie lub zdalne
                zakończenie sesji przez organizatora. Po zakończeniu sesji Aplikacja przestaje zbierać i wysyłać
                jakiekolwiek dane.
              </p>
            </div>

            <div>
              <h2 className="text-xl text-white font-bold mb-3">8. Kontakt</h2>
              <p>
                Wszelkie pytania dotyczące niniejszego Regulaminu prosimy kierować na adres{' '}
                <a href="mailto:monitgpssystem@gmail.com" className="text-cyan-400 hover:underline">
                  monitgpssystem@gmail.com
                </a>.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="py-8 px-6 glass-effect border-t border-white/5 mt-auto">
        <div className="max-w-7xl mx-auto flex flex-col md:flex-row items-center justify-between text-sm text-gray-500">
          <div className="flex flex-col md:flex-row items-center gap-4">
            <p>© 2026 MonitGPS. Wszystkie prawa zastrzeżone.</p>
            <a href="/privacy" className="hover:text-cyan-400 transition-colors underline decoration-white/20 underline-offset-4">Polityka Prywatności</a>
          </div>
          <div className="mt-4 md:mt-0">
            <p>Profesjonalny monitoring dla sportów motorowych</p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Terms;
